export const MODAL_STATUSES = {
  DEFAULT: 'default',
  DANGER: 'danger'
}
